import { types } from '../../../constants/ActionTypes'
import { deepCopy } from '../../../lib'

const initialState = {
  chatRooms: {},
  message: '',
}

const chatCard = (state = initialState, action) => {
  var liveId, newChatRooms, index
  switch (action.type) {
    case types.chatCard.CHANGED_TEXT:
      if (action.text.length > 50) {
        return state
      }
      return { ...state, [action.name]: action.text }
    case types.live.RECEIVE_ADD_CHAT_MESSAGE:
      newChatRooms = deepCopy(state.chatRooms)
      liveId = action.liveId
      if (!newChatRooms[liveId]){
        newChatRooms[liveId] = {
          chat: []
        }
      }
      newChatRooms[liveId].chat.push({
        mid : action.mid,
        displayName : action.displayName,
        photoURL : action.photoURL,
        message : action.message,
        boardContext : action.boardContext,
        timestamp : action.timestamp,
      })
      index = 0
      newChatRooms[liveId].chat = newChatRooms[liveId].chat.map((chat) => {
        if (chat.boardContext) {
          index += 1
          chat.analyzeId = index
        }
        return chat
      })
      return { ...state, chatRooms: newChatRooms }
    case types.live.RECEIVE_ALL_CHAT_MESSAGE:
      liveId = action.liveId
      newChatRooms = deepCopy(state.chatRooms)
      if (!newChatRooms[liveId]) {
        newChatRooms[liveId] = {
          chat: [],
          users: []
        }
      }
      index = 0
      newChatRooms[liveId].chat = action.allMessage
      newChatRooms[liveId].chat = newChatRooms[liveId].chat.map((chat) => {
        if (chat.boardContext) {
          index += 1
          chat.analyzeId = index
        }
        return chat
      })
      return { ...state, chatRooms: newChatRooms }
    case types.live.RECEIVE_JOINING_USERS_IN_ROOM:
      liveId = action.liveId
      newChatRooms = deepCopy(state.chatRooms)
      if (!newChatRooms[liveId]) {
        newChatRooms[liveId] = {
          chat: [],
          users: []
        }
      }
      newChatRooms[action.liveId].totalUser = action.users.length
      newChatRooms[action.liveId].users = action.users
      return { ...state, chatRooms: newChatRooms}
    default:
      return state
  }
}

export default chatCard


// WEBPACK FOOTER //
// ./src/reducers/Common/Chat/ChatCard.js